import React, { Component } from 'react'
import Login from './Login'
import { Button } from 'react-bootstrap'

export default class StartPage extends Component {
  render() {
    return (
      <div className="container">
        <h2>Willkommen bei RinkBingo</h2>
        <br />
        <h4>RinkBingo ist ein interaktiv Spiel von der <b>Inspectron AG</b></h4>
        <h4>Bitte melden sie sich an um weiter zum Spiel zu gelangen</h4>
        <Button className="btn-sample" onClick={() => this.props.history.push('/login') }>Login</Button> <Button className="btn-sample" onClick={() => this.props.history.push('/register') }>Registrieren</Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/StartPage.jsx